import { render } from "./AppLoader.vue?vue&type=template&id=2f544e16&scoped=true"
import script from "./AppLoader.vue?vue&type=script&lang=js"
export * from "./AppLoader.vue?vue&type=script&lang=js"

import "./AppLoader.vue?vue&type=style&index=0&id=2f544e16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f544e16"]])

export default __exports__